<template>
    <div style="background-color: #e3e3e3" class="orderSummary">
        <van-nav-bar title="合同收款汇总" left-arrow  @click-left="onClickLeft"  @click-right="onClickRight" >
            <span class="iconfont icon-funnel1" slot="right" ></span>
        </van-nav-bar>
        <div class="fieldDate">
            <van-field-date v-model="startTime"  input-align="right" type="date" :formatter="formatter"  @change="onRefresh"></van-field-date>
            <div>
                ——
            </div>
            <van-field-date v-model="endTime" format="yyyy-MM-dd" type="date" :formatter="formatter" @change="onRefresh"></van-field-date>
        </div>

        <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />

        <div class="margin">
            <van-cell>
                <van-row type="flex" justify="space-between">
                    <van-col span="6" offset="2" style="color: #969799">合同总额</van-col>
                    <van-col span="6" offset="3" style="color: #969799">待收款</van-col>
                    <van-col span="7" offset="2" style="color: #969799">已收款</van-col>
                </van-row>
                <van-row type="flex" justify="space-between">
                    <van-col span="6" offset="2">{{summaryData.amount}}</van-col>
                    <van-col span="6" offset="3">{{summaryData.amount-summaryData.receivedAmount-summaryData.badDebtAmount}}</van-col>
                    <van-col span="7" offset="2">{{summaryData.receivedAmount}}</van-col>
                </van-row>
            </van-cell>
            <van-cell>
                <van-row type="flex" justify="space-between">
                    <van-col span="6" offset="2" style="color: #969799">已逾期</van-col>
                    <van-col span="6" offset="3" style="color: #969799">坏账金额</van-col>
                    <van-col span="7" offset="2" style="color: #969799">已开票</van-col>
                </van-row>
                <van-row type="flex" justify="space-between">
                    <van-col span="6" offset="2">{{summaryData.beOverdueAmount}}</van-col>
                    <van-col span="6" offset="3">{{summaryData.badDebtAmount}}</van-col>
                    <van-col span="7" offset="2">{{summaryData.invoicedAmount}}</van-col>
                </van-row>
            </van-cell>
            <van-cell>
                <van-row type="flex" justify="space-between">
                    <van-col span="6" offset="2" style="color: #969799">待开票</van-col>
                </van-row>
                <van-row type="flex" justify="space-between">
                    <van-col span="6" offset="2" >{{summaryData.amount-summaryData.invoicedAmount}}</van-col>
                </van-row>
            </van-cell>
        </div>
        <div style="background-color: white">
            <p style="margin: 0; padding: 1rem;">
                <span class="iconfont icon-money"  style="color: #1297DB;" >收款明细</span>
            </p>
            <van-pull-refresh v-model="refreshing"  @refresh="onRefresh">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getReceiptSummary">
                    <div v-for="receiptSummary in receiptSummaryList" class="card" :key="receiptSummary.uuid" @click="summaryDetail(receiptSummary)" >
                        <table class="layout">
                            <tr>
                                <td colspan="3">
                                    <span class="iconfont icon-user" >  {{receiptSummary.customerName}}</span>
                                </td>
                                <td colspan="2" style="text-align: right;">
                                    <span style="color: #FF1717;" v-if="receiptSummary.status === '已逾期'">{{receiptSummary.status}}</span>
                                    <span style="color: #1297DB;" v-if="receiptSummary.status === '待收款'">{{receiptSummary.status}}</span>
                                    <span style="color: #CC6633;" v-if="receiptSummary.status === '坏账'">{{receiptSummary.status}}</span>
                                    <span v-if="receiptSummary.status === '已收款'"><van-tag color="#F63C53" plain>已收迄</van-tag></span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" class="title"><span class="iconfont icon-date"></span>
                                    {{receiptSummary.planReceiptDate}}</td>
                                <td></td>
                                <td colspan="2" class="title" style="text-align: right;" ><span class="iconfont icon-money-rmb"></span>
                                    {{receiptSummary.amount}}</td>
                            </tr>
                            <tr>
                                <td class="progressTitle">已收款</td>
                                <td colspan="3"><van-progress pivot-text="" color="#66CC66" :percentage="receiptSummary.amountProgress" /></td>
                                <td class="progressAmount">{{receiptSummary.receivedAmount}}</td>
                            </tr>
                            <tr>
                                <td class="progressTitle">已开票</td>
                                <td colspan="3"><van-progress pivot-text="" color="#66CC66" :percentage="receiptSummary.invoiceProgress" /></td>
                                <td class="progressAmount">{{receiptSummary.invoicedAmount}}</td>
                            </tr>
                        </table>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
    </div>
</template>

<script>
    /**
     * import  引用
     */
    import {Tag, Panel, Field, List, PullRefresh, Progress, NavBar, Row, Col, Cell, CellGroup, Divider,DatetimePicker, Popup,ActionSheet } from 'vant';
    import userInfo from '../store/userInfo';
    import orderService from "../service/orderService";
    import moment from "moment";
    import {formatDictionary} from "../utils/dictionary";
    import {formatMoney} from "../utils/money";
    import VanFieldDate from "../components/VantFieldDate";

    export default {
        /**
         * 页面数据存放位置
         */
        data: function () {
            return {
                summaryData:{
                    //合同总额
                    amount:0,
                    //已收金额
                    receivedAmount:0,
                    //坏账金额
                    badDebtAmount:0,
                    //已开票金额
                    invoicedAmount:0,
                    //逾期金额
                    beOverdueAmount:0,
                },
                receiptSummaryList: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                refreshing: false,
                startTime:moment(new Date().setDate(1)).format('YYYY-MM-DD'),
                endTime:moment(new Date()).format('YYYY-MM-DD'),
                status:'',
                showPop: false,
                showPopData: false,
                show: false,
                actions:[
                    { name: '全部',value:'' },
                    { name: '待收款' ,value:'待收款' },
                    { name: '已收款' ,value:'已收款' },
                    { name: '坏账',value:'坏账'  },
                    { name: '已逾期' ,value:'已逾期' },
                ]
            }
        },
        /**
         * 用户信息
         */
        store: userInfo,
        /**
         * 组件注册
         */
        components: {
            VanFieldDate,
            [Tag.name]: Tag,
            [Progress.name]: Progress,
            [Panel.name]: Panel,
            [Field.name]: Field,
            [List.name]: List,
            [PullRefresh.name]: PullRefresh,
            [NavBar.name]:NavBar,
            [Row.name]:Row,
            [Col.name]:Col,
            [Cell.name]:Cell,
            [CellGroup.name]:CellGroup,
            [Divider.name]:Divider,
            [DatetimePicker.name]:DatetimePicker,
            [Popup.name]:Popup,
            [ActionSheet .name]:ActionSheet
        },
        computed: {
        },
        props: {
            value: {
                type: [String],
                default: undefined
            },
            label: {
                type: String,
                default: null
            },
            format: {
                type: String,
                default: null
            }
        },
        created: async function () {
            this.getReceiptSummaryTime();
        },
        methods : {
            onSelect(item) {
                // 点击选项时默认不会关闭菜单，可以手动关闭
                this.show = false;
                // eslint-disable-next-line no-undef
                this.status = item.value;
                this.onRefresh();
            },
            //时间进行格式化处理
            formatter(type, value) {
                if (type === 'year') {
                    return `${value}年`;
                } else if (type === 'month') {
                    return `${value}月`
                }else if(type === 'day'){
                    return `${value}日`
                }
                return value;
            },

            /**
             * 合同收款汇总
             */
            async getReceiptSummary(){
                this.pageIndex++;
                let resp = await orderService.getReceiptSummaryList(this.pageIndex,this.startTime,this.endTime,this.status);
                resp.data.Data.data.forEach(receiptSummary => {
                    //日期格式化
                    receiptSummary.planReceiptDate = moment(receiptSummary.planReceiptDate).format('YYYY-MM-DD');
                    receiptSummary.amountProgress = receiptSummary.receivedAmount ? receiptSummary.receivedAmount*100 /receiptSummary.planReceiptAmount : 0;
                    receiptSummary.invoiceProgress = receiptSummary.invoicedAmount ? receiptSummary.invoicedAmount*100 / receiptSummary.planReceiptAmount  : 0;
                    //金额格式化
                    receiptSummary.amount = formatMoney(receiptSummary.planReceiptAmount || 0);
                    receiptSummary.receivedAmount = formatMoney(receiptSummary.receivedAmount||0);
                    receiptSummary.invoicedAmount = formatMoney(receiptSummary.invoicedAmount||0);

                });
                // 字典格式化
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.loading = false;
                this.refreshing = false;
                this.receiptSummaryList = [...this.receiptSummaryList, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.receiptSummaryList.length;
            },
            async getReceiptSummaryTime(){
                let resp = await orderService.getReceiptSummaryStatistics(this.startTime,this.endTime);
                this.summaryData={amount:0,
                    receivedAmount:0,
                    badDebtAmount:0,
                    invoicedAmount:0,
                    beOverdueAmount:0,};
                resp.data.Data.forEach(receiptSummary => {
                    this.summaryData.amount += receiptSummary.planReceiptAmount || 0;
                    this.summaryData.receivedAmount += receiptSummary.receivedAmount || 0;
                    this.summaryData.badDebtAmount += receiptSummary.badDebtAmount || 0;
                    this.summaryData.invoicedAmount += receiptSummary.invoicedAmount || 0;
                    this.summaryData.beOverdueAmount += receiptSummary.beOverdueAmount || 0;
                });
            },
            onRefresh(){
                this.finished = false;
                this.pageIndex = 0;
                this.receiptSummaryList = [];
                this.getReceiptSummary();
                this.getReceiptSummaryTime();
            },
            summaryDetail(receiptSummary){
                window.open("/#/order/detail?id="+receiptSummary.orderId+"&selected=1&isHiddenTitle=1&isSummaryEntry=true")
            },
            onClickRight(){
                this.show = true;
            },
            onClickLeft(){
                window.open("colseWebView");
            }
        }
    };
</script>

<style>
    .orderSummary table tr{
        height: 2rem;
    }
    .orderSummary table td{
        width: 20%;
    }
    .orderSummary .progressTitle{
        text-align: right;
        color: #999999;
    }
    .orderSummary .progressAmount{
        color: #999999;
        padding-left: 0.5rem;
    }
    .orderSummary .title {
        font-size: 0.9rem;
    }
    .orderSummary .margin{
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .orderSummary .fieldDate{
        width: 100%;
        display: flex;
        justify-content: center;
        background-color: white;
        line-height: 2.6rem;
    }
    .orderSummary .fieldDate input{
        color:#1297DB !important;
    }
</style>